export default {
  // pullSuccessful.vue - 拉取成功弹窗
  pullSuccessful: {
    dialogTitle: "提示",
    tipText: "已拉取该地址最新的1万条交易记录",
    addressLabel: "地址：",
    transactionTimeRange: "交易时间范围：",
    warningPulling: "全量数据拉取中，请耐心等待",
    cancelBtn: "取消",
    pullAllBtn: "拉全量",
    pullNotifyTitle: "提示",
    pullNotifyMessage:
      "数据拉取中，可能需要一些时间，请耐心等待，稍后再查看节点详情",
  },

  // nodedetailTip.vue - 节点详情提示
  nodeDetailTip: {
    transactionData: "交易数据：",
    fullData: "全量数据",
    recentUpdate: "最近更新：",
    limitedData: "交易数据仅近期1万条",
    syncAll: "同步全量",
    syncing: "同步中",
    syncFailed: "同步失败",
    retry: "重试",
    tooltipContent:
      "数据拉取中，可能需要一些时间，请耐心等待，稍后再查看节点详情",
    notifyTitle: "提示",
    notifyMessage:
      "数据拉取中，可能需要一些时间，请耐心等待，稍后再查看节点详情",
  },

  // datasuccess.vue - 数据同步完成弹窗
  dataSuccess: {
    syncCompleteText: "历史数据同步完成",
    addressLabel: "地址：",
    transactionTimeRange: "交易时间范围：",
    warningTip: "先收起已扩展节点，重新展开以获取最新交易数据",
    confirmBtn: "确认",
  },
};
